import {SyncIcon} from '@primer/octicons-react'
import {Tooltip} from '@primer/react-brand/esm'
import {clsx} from 'clsx'
import {useEffect, useRef} from 'react'

import {ICONS} from '../../svgs'

import Styles from './PlayButton.module.css'

export const PLAY_BUTTON_ACTIONS = ['play', 'pause', 'replay'] as const
export type PlayButtonAction = (typeof PLAY_BUTTON_ACTIONS)[number]

export const PLAY_BUTTON_SIZES = ['small', 'default'] as const

export type PlayButtonProps = {
  action: PlayButtonAction
  size?: (typeof PLAY_BUTTON_SIZES)[number]
  onClick: () => void
  label: string
  className?: string
}

export const PlayButton = ({action, onClick, label, className, size = 'default'}: PlayButtonProps) => {
  const buttonRef = useRef<HTMLButtonElement>(null)
  const hasFocusRef = useRef<boolean>(false)
  const isReplay = action === 'replay'

  useEffect(() => {
    // Adding or removing the Tooltip remounts the button.
    if (hasFocusRef.current) buttonRef.current?.focus()
  }, [isReplay])

  const button = (
    <button
      ref={buttonRef}
      type="button"
      className={clsx(Styles['PlayButton'], size !== 'default' && Styles[`PlayButton--${size}`], className)}
      onClick={onClick}
      onFocus={() => {
        hasFocusRef.current = true
      }}
      onBlur={() => {
        hasFocusRef.current = false
      }}
      aria-label={isReplay ? undefined : label}
    >
      {isReplay ? <SyncIcon size={16} /> : ICONS[action]}
    </button>
  )

  return isReplay ? (
    <Tooltip ref={buttonRef} text={label} type="label" direction="n">
      {button}
    </Tooltip>
  ) : (
    button
  )
}
